import { BadgeV3 } from '@cimplico/components';
import { SubscriptionTier, SubscriptionTierV2 } from '../../../types/firm';
import { HeartIcon } from '@heroicons/react/20/solid';

type FirmSubscriptionTierBadgeProps = {
    subscriptionTier?: SubscriptionTier | SubscriptionTierV2;
};

function FirmSubscriptionTierBadge({ subscriptionTier }: FirmSubscriptionTierBadgeProps): JSX.Element {
    switch (subscriptionTier) {
        case SubscriptionTier.BASIC:
            return <BadgeV3 color="blue" label="Basic" leftIcon={<HeartIcon />} />;
        case SubscriptionTier.ESSENTIAL:
            return <BadgeV3 color="yellow" label="Essential" leftIcon={<HeartIcon />} />;
        case SubscriptionTier.PROFESSIONAL:
            return <BadgeV3 color="green" label="Professional" leftIcon={<HeartIcon />} />;
        case SubscriptionTier.ENTERPRISE:
            return <BadgeV3 color="indigo" label="Enterprise" leftIcon={<HeartIcon />} />;
        case 'STARTER':
            return <BadgeV3 label="Starter" leftIcon={<HeartIcon />} />;
        case 'SILVER':
            return <BadgeV3 label="Silver" leftIcon={<HeartIcon />} />;
        case 'GOLD':
            return <BadgeV3 label="Gold" leftIcon={<HeartIcon />} />;
        case 'PLATINUM':
            return <BadgeV3 label="Platinum" leftIcon={<HeartIcon />} />;
        default:
            return <></>;
    }
}
export default FirmSubscriptionTierBadge;
